"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadExternalRegistry = exports.getRegistryManifestURL = exports.getRegistryBundleID = exports.EXTERNAL_REGISTRY_OVERRIDE_NAMESPACE = void 0;
const createException_1 = require("../createException");
exports.EXTERNAL_REGISTRY_OVERRIDE_NAMESPACE = 'registry';
function getRegistryBundleID(host) {
    return `${host}Registry`;
}
exports.getRegistryBundleID = getRegistryBundleID;
function getRegistryManifestURL(baseURL) {
    return `${baseURL}/registry-manifest.min.json`;
}
exports.getRegistryManifestURL = getRegistryManifestURL;
async function loadExternalRegistry({ resourceLoader, url, host, }) {
    const response = await resourceLoader.fetch({
        url: getRegistryManifestURL(url),
    });
    const manifest = JSON.parse(response);
    const id = getRegistryBundleID(host);
    if (!manifest[`${id}.js`]) {
        throw createException_1.createException(createException_1.RegistryErrorCode.NoRegistryOverrideForHost);
    }
    const loadBundle = resourceLoader.createBundleLoader({ environment: {} });
    const runtimeURL = manifest['webpack-runtime.js'];
    if (runtimeURL) {
        await loadBundle({
            url: runtimeURL,
        });
    }
    const bundleUrl = manifest[`${id}.js`];
    const registry = await loadBundle({
        url: bundleUrl,
        id,
    });
    return registry.default;
}
exports.loadExternalRegistry = loadExternalRegistry;
//# sourceMappingURL=loadExternalRegistry.js.map